import React, { useState } from 'react';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';
const FONT_SANS = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

function Toggle({ checked, onChange }) {
  return (
    <label style={{ position: 'relative', display: 'inline-block', width: '50px', height: '28px' }}>
      <input type="checkbox" checked={checked} onChange={onChange} style={{ display: 'none' }} />
      <span style={{
        position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0,
        background: checked ? WALNUT : '#ccc', borderRadius: '28px', transition: '0.3s'
      }}>
        <span style={{
          position: 'absolute', content: '""', height: '20px', width: '20px',
          left: checked ? '26px' : '4px', bottom: '4px', background: 'white', borderRadius: '50%', transition: '0.3s'
        }} />
      </span>
    </label>
  );
}

function ToggleRow({ title, sub, checked, onChange, last }) {
  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '16px 0', borderBottom: last ? 'none' : '1px solid rgba(139,69,19,0.06)'
    }}>
      <div>
        <div style={{ fontSize: '14px', fontWeight: '600', color: INK, marginBottom: '4px' }}>{title}</div>
        <div style={{ fontSize: '12px', color: STONE }}>{sub}</div>
      </div>
      <Toggle checked={checked} onChange={onChange} />
    </div>
  );
}

export default function NotificationPreferences() {
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [smsNotifications, setSmsNotifications] = useState(true);
  const [pushNotifications, setPushNotifications] = useState(true);
  const [dailySummaryTime, setDailySummaryTime] = useState('04:00');

  return (
    <div style={{ fontFamily: FONT_SANS }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '16px'
      }}>
        Notification Preferences
      </h3>

      <div style={{
        padding: '20px',
        background: PAPER,
        borderRadius: '12px',
        border: '1px solid rgba(139,69,19,0.1)'
      }}>
        <ToggleRow
          title="Email Notifications"
          sub="Receive updates via email"
          checked={emailNotifications}
          onChange={(e) => setEmailNotifications(e.target.checked)}
        />
        <ToggleRow
          title="SMS Notifications"
          sub="Receive updates via text message"
          checked={smsNotifications}
          onChange={(e) => setSmsNotifications(e.target.checked)}
        />
        <ToggleRow
          title="Push Notifications"
          sub="Receive browser notifications"
          checked={pushNotifications}
          onChange={(e) => setPushNotifications(e.target.checked)}
          last
        />

        {/* Daily Summary Time */}
        <div style={{ marginTop: '20px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            color: INK,
            marginBottom: '8px'
          }}>
            Daily Summary Email Time
          </label>
          <input
            type="time"
            name="twp-settings-summary-time"
            autoComplete="off"
            value={dailySummaryTime}
            onChange={(e) => setDailySummaryTime(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid rgba(139,69,19,0.2)',
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: FONT_SANS,
              outline: 'none',
              background: PAPER
            }}
            onFocus={(e) => e.target.style.borderColor = WALNUT}
            onBlur={(e) => e.target.style.borderColor = 'rgba(139,69,19,0.2)'}
          />
          <div style={{
            fontSize: '12px',
            color: STONE,
            marginTop: '4px'
          }}>
            Time to send daily job summary (Central Time)
          </div>
        </div>

        {/* Save Button */}
        <button
          style={{
            marginTop: '20px',
            width: '100%',
            padding: '12px',
            background: WALNUT,
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            fontFamily: FONT_SANS,
            color: 'white',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#A0522D'}
          onMouseLeave={(e) => e.currentTarget.style.background = WALNUT}
        >
          Save Notification Settings
        </button>
      </div>
    </div>
  );
}
